export const RELATED_CONTENT_TITLE = 'Need answers fast?';
export const CONTENT_BTN_TITLE = 'Show related content';
export const NO_CONTENT_RESULT = 'No related content found.';

export const ARTICLE_FORMAT = 'Format:';
